<template>
    <div class="banner bng-sport-banner-cashback-bonus">
        <img
            :src="isMobilePhone ? '/static/banners/sport-home-banner/mobile/cashback_bonus.jpg' : '/static/banners/sport-home-banner/desktop/cashback_bonus.jpg'"
        />
        <div class="content">
            <div>
                <div>
                    <b>{{"components.common.banners.sport-banners.cashback-bonus.msg1" | translate}}</b>
                    <span>{{percent}}%</span>
                </div>
            </div>
        </div>
        <div class="detailed">
            <a @click="goToBonusRules()">{{"components.common.banners.sport-banners.cashback-bonus.read more" | translate}}</a>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import isMobile from 'ismobilejs';

export default {
    name: 'sport-banner-cashback-bonus',
    computed: {
        client() {
            return Vue.state.client.get();
        },
        isMobilePhone() {
            return isMobile.phone;
        },
        percent() {
            return this.client && this.client.bonus.cashback && this.client.bonus.cashback.percent;
        }
    },
    methods: {
        async goToBonusRules() {
            await Vue.router.teleport.bonusRules();
        }
    }
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/banners/sport-banners/cashback-bonus.vue